import { useContext } from 'react';
import { TimelineContext } from '@src/new-components/Timeline/TimelineProvider';

/**
 * Read the timeline scale/scroll context.
 * Must be used inside a <TimelineProvider>.
 */
const useTimeline = () => {
  const context = useContext(TimelineContext);
  if (!context) {
    throw new Error('useTimeline must be used within a TimelineProvider');
  }
  return context;
};

export default useTimeline;
